export default __webpack_public_path__ + "static/media/closet3-1024w.ca00dac2.avif";